import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-water-fasting',
	landing: {
		ids: ['loader-water-balance-f'],
		route: {
			path: '/water-fasting-f',
			name: 'female-water-fasting-funnel',
		},
	},
	funnel: {
		id: 'ob-water-fasting-female',
		route: {
			path: '/water-fasting-f/ob/:page(.*)?',
			name: 'female-water-fasting',
		},
		slug: 'female-water-fasting',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-f',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
